import React from 'react';
import './entity-popup-item.scss';
import { ListItem } from '../entity-selector';
import { Checkbox, Popover } from 'antd';
import Arrow from '@svg/chevron-down_20.svg?react';

export interface EntityPopupItemProps {
    item: ListItem;
    onChange: (checked: boolean, item: ListItem) => void;
    isSelected: boolean;
    EntityLabel: React.FC<{ data: any }>;
    EntityInfo?: React.FC<{ data: any }>;
}

export const EntityPopupItem: React.FC<EntityPopupItemProps> = ({
                                                                              item,
                                                                              onChange,
                                                                              isSelected,
                                                                              EntityLabel,
                                                                              EntityInfo
                                                                          }) => {
    const data = item.data;

    return (
        <span className={'entity-item'}>
            <Checkbox
                className={'item-label'}
                checked={isSelected}
                onChange={(e) => onChange(e.target.checked, item)}
            >
                <EntityLabel data={data}/>
            </Checkbox>
          {EntityInfo && <Popover
                content={<EntityInfo data={data}/>}
                placement={'right'}
                showArrow={false}
                overlayClassName={'entity-item-tooltip'}
            >
                <span className={'more-details'}>
                  <Arrow/>
                </span>
          </Popover>}
    </span>);
};